import React from "react";
import moment from "moment";
import { USER_FILTER_KEYS } from "../util";
import ReportyByGroupContext from "./components/Reports/Users/byGroup/ReportyByGroupContext";

const ReportUsersGrouped = () => {
  const [userFilters, setUserFilters] = React.useState({
    [USER_FILTER_KEYS.COUNTRIES]: [],
    [USER_FILTER_KEYS.STATES]: [],
    [USER_FILTER_KEYS.ROLES]: [],
    [USER_FILTER_KEYS.CUSTOMER_SITUATIONS]: [],
    [USER_FILTER_KEYS.AGENT_SITUATIONS]: [],
    [USER_FILTER_KEYS.AGE_RANGES]:[],
    [USER_FILTER_KEYS.SELECTED_MONTH_YEAR]: moment(),
    [USER_FILTER_KEYS.GROUP]: null,
  });

  return (
    <ReportyByGroupContext
      pageTitle="app.report.byGroup"
      userFilters={userFilters}
      setUserFilters={setUserFilters}
      fetchStatesEnabled
    />
  );
};



export default ReportUsersGrouped;
